export default __webpack_public_path__ + "static/media/icons-calendar-18-px.e2671c50.svg";